import { jsx as a } from "react/jsx-runtime";
import n from "../components/AccordionIcon/AccordionIcon.js";
const i = {
  defaultProps: {
    expandIcon: /* @__PURE__ */ a(n, {})
  },
  styleOverrides: {
    root: ({ theme: o }) => ({
      color: o.palette.text.primary,
      minHeight: "auto",
      padding: o.spacing(1, 2),
      "&.Mui-expanded": {
        minHeight: "auto"
      },
      // TODO: These should be palette tokens, but we're not there yet!
      "&.Mui-focusVisible": {
        backgroundColor: "rgba(102, 188, 255, 0.16)",
        ...o.applyStyles("dark", {
          backgroundColor: "rgba(0, 74, 204, 0.16)"
        })
      }
    }),
    content: ({ theme: o }) => ({
      fontFamily: o.typography.body1.fontFamily,
      fontSize: o.spacing(2),
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: 1.6,
      margin: 0,
      "&.Mui-expanded": {
        margin: 0
      }
    }),
    expandIconWrapper: ({ theme: o }) => ({
      color: o.palette.text.primary,
      padding: o.spacing(1),
      "&.Mui-expanded": {
        transform: "rotate(0deg)"
      }
    })
  }
};
export {
  i as default
};
